<script>
/**
 * Report of all cost by milestones
 * -> costs-report
 */
import MilestoneAllocationService from "@/services/MilestoneAllocationService";
import CostSubmenu from "./components/CostSubmenu";
import { mapGetters } from "vuex";
import VListVouchers from "@/components/Costs/VListVouchers";
import OuterDashCard from "@/components/Cards/OuterDashCard";

export default {
    props: {
        project_id: {}
    },
    components: { CostSubmenu, VListVouchers, OuterDashCard },
    data() {
        return {
            loading: true,
            data: [],
            hashed: {},
            meta: {},
            nodata: false,
            triggers: {},
            BK: false,
            showVouchersModal: false,
            voucherCtxCategory: "",
            voucherCtxMilestone: ""
        };
    },
    computed: {
        ...mapGetters("auth", ["getAclMap"])
    },
    async created() {
        this.BK = this.$aclCan(this.$ACL.CUSTOM_PLANNING_BK_SH_NC);
        this.loading = true;
        await this.fetchData();
        this.data.forEach(e => {
            this.$set(this.triggers, e.m_ident, false);
        });
        this.loading = false;
    },
    methods: {
        async fetchData() {
            try {
                const { data } = await MilestoneAllocationService.GET_report(
                    this.project_id
                );
                this.data = data.data;
                this.meta = data.meta;
                this.nodata = false;
            } catch (e) {
                console.log("f.e.", e);
                this.nodata = true;
            }
        },
        trigger(m_ident) {
            this.triggers[m_ident] = !this.triggers[m_ident];
        },
        /**
         * Show underlying vouchers
         * @param category_id
         * @param milestone_id
         */
        showVouchers(category_id, milestone_id) {
            this.voucherCtxCategory = category_id;
            this.voucherCtxMilestone = milestone_id;
            this.showVouchersModal = true;
        }
    }
};
</script>

<template>
    <div>
        <div class="container-fluid">
            <div class="row card-wrapper">
                <div class="col-12">
                    <card>
                        <div
                            class="d-flex align-items-center mb-0 justify-content-between"
                        >
                            <h2 class="">
                                {{ $t("vouchers.cost_report") }}
                            </h2>
                            <cost-submenu :project-id="project_id" me="costs" />
                        </div>
                        <div class="text-right mt-3">
                            <a
                                :href="
                                    `/v1/milestone-allocations/all-projects-report`
                                "
                                class="btn btn-info btn-sm"
                                ><i class="far fa-file-csv"></i>
                                {{
                                    $t("vouchers.download_csv_for_all_projects")
                                }}</a
                            >
                            <a
                                :href="
                                    `/v1/milestone-allocations/report/${project_id}?csv=1`
                                "
                                class="btn btn-primary btn-sm"
                                ><i class="far fa-file-csv"></i>
                                {{ $t("vouchers.download_csv") }}</a
                            >
                        </div>
                    </card>
                    <v-loader :loading="loading" v-if="loading" />
                    <template v-else-if="!nodata">
                        <div class="row" v-if="true">
                            <div class="col">
                                <OuterDashCard
                                    icon="far fa-sigma"
                                    :title="
                                        $t('vouchers.stat_card_total_costs')
                                    "
                                    >{{
                                        $n(meta.stats.total, {
                                            style: "currency",
                                            currency: meta.stats.currency,
                                            currencyDisplay: "code",
                                            maximumFractionDigits: 0,
                                            minimumFractionDigits: 0
                                        })
                                    }}</OuterDashCard
                                >
                            </div>
                            <div class="col">
                                <OuterDashCard
                                    icon="far fa-money-bill"
                                    :title="$t('vouchers.stat_card_costs')"
                                    >{{
                                        $n(meta.stats.total_costs, {
                                            style: "currency",
                                            currency: meta.stats.currency,
                                            currencyDisplay: "code",
                                            maximumFractionDigits: 0,
                                            minimumFractionDigits: 0
                                        })
                                    }}</OuterDashCard
                                >
                            </div>
                            <div class="col">
                                <OuterDashCard
                                    icon="far fa-stopwatch"
                                    :title="$t('vouchers.stat_card_hour_costs')"
                                    >{{
                                        $n(meta.stats.total_hours, {
                                            style: "currency",
                                            currency: meta.stats.currency,
                                            currencyDisplay: "code",
                                            maximumFractionDigits: 0,
                                            minimumFractionDigits: 0
                                        })
                                    }}</OuterDashCard
                                >
                            </div>
                            <div class="col">
                                <OuterDashCard
                                    icon="far fa-car"
                                    :title="
                                        $t('vouchers.stat_card_travel_costs')
                                    "
                                    >{{
                                        $n(meta.stats.total_travel, {
                                            style: "currency",
                                            currency: meta.stats.currency,
                                            currencyDisplay: "code",
                                            maximumFractionDigits: 0,
                                            minimumFractionDigits: 0
                                        })
                                    }}</OuterDashCard
                                >
                            </div>
                        </div>
                        <hr class="mt-1" />
                        <card
                            v-if="'amount_category' in meta.no_milestone"
                            class="card-no-milestone"
                        >
                            <div class="row">
                                <div class="col">
                                    <div class="d-flex justify-content-between">
                                        <h4 class="pb-1">
                                            <i
                                                class="far fa-exclamation text-warning"
                                            ></i>
                                            {{
                                                $t(
                                                    "vouchers.costs_without_assigned_milestone"
                                                )
                                            }}
                                        </h4>
                                        <div
                                            class="text-bold text-default text-right"
                                        >
                                            <div>
                                                <span class="mini-text">{{
                                                    $t("vouchers.hours")
                                                }}</span>
                                                <template
                                                    v-if="
                                                        parseFloat(
                                                            meta.no_milestone
                                                                .amount_category
                                                        ) > 0
                                                    "
                                                >
                                                    {{
                                                        $n(
                                                            meta.no_milestone
                                                                .amount_category,
                                                            {
                                                                style:
                                                                    "currency",
                                                                currency:
                                                                    meta
                                                                        .no_milestone
                                                                        .currency,
                                                                currencyDisplay:
                                                                    "code",
                                                                maximumFractionDigits: 0,
                                                                minimumFractionDigits: 0
                                                            }
                                                        )
                                                    }}</template
                                                ><template v-else>---</template>
                                            </div>
                                            <div>
                                                <span class="mini-text">{{
                                                    $t(
                                                        "vouchers.transportation"
                                                    )
                                                }}</span>
                                                <template
                                                    v-if="
                                                        parseFloat(
                                                            meta.no_milestone_travel
                                                        ) > 0
                                                    "
                                                    >{{
                                                        $n(
                                                            meta
                                                                .no_milestone_travel
                                                                .amount_category,
                                                            {
                                                                style:
                                                                    "currency",
                                                                currency:
                                                                    meta
                                                                        .no_milestone_travel
                                                                        .currency,
                                                                currencyDisplay:
                                                                    "code",
                                                                maximumFractionDigits: 0,
                                                                minimumFractionDigits: 0
                                                            }
                                                        )
                                                    }}</template
                                                ><template v-else>---</template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </card>

                        <card v-for="(m, idx) in data">
                            <div class="row">
                                <div class="col">
                                    <div class="d-flex justify-content-between">
                                        <h4 class="pb-1">
                                            M{{ m.m_ident }}
                                            {{ m.milestone_name }}
                                            <base-button
                                                @click="trigger(m.m_ident)"
                                                size="sm"
                                                type="primary"
                                                outline
                                                ><i class="far fa-plus"></i
                                            ></base-button>
                                        </h4>
                                        <div
                                            class="text-bold text-default text-right"
                                        >
                                            <div>
                                                <span class="mini-text">{{
                                                    $t("vouchers.costs")
                                                }}</span>
                                                {{
                                                    $n(
                                                        m.milestone_amount_cost,
                                                        {
                                                            style: "currency",
                                                            currency:
                                                                m.currency,
                                                            currencyDisplay:
                                                                "code",
                                                            maximumFractionDigits: 0,
                                                            minimumFractionDigits: 0
                                                        }
                                                    )
                                                }}
                                            </div>
                                            <div>
                                                <span class="mini-text">{{
                                                    $t("vouchers.hours")
                                                }}</span>
                                                {{
                                                    $n(m.total_hours_amount, {
                                                        style: "currency",
                                                        currency:
                                                            m.total_hours_amount_currency,
                                                        currencyDisplay: "code",
                                                        maximumFractionDigits: 0,
                                                        minimumFractionDigits: 0
                                                    })
                                                }}
                                            </div>
                                            <div>
                                                <span class="mini-text">{{
                                                    $t("vouchers.travels")
                                                }}</span>

                                                {{
                                                    $n(m.total_travel_amount, {
                                                        style: "currency",
                                                        currency:
                                                            m.total_travel_amount_currency,
                                                        currencyDisplay: "code",
                                                        maximumFractionDigits: 0,
                                                        minimumFractionDigits: 0
                                                    })
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                    <template v-if="triggers[m.m_ident]">
                                        <hr class="my-3" />
                                        <div class="row">
                                            <div class="col" v-if="BK">
                                                <div>
                                                    <dl>
                                                        <dt>
                                                            {{
                                                                $t(
                                                                    "vouchers.total_allocated"
                                                                )
                                                            }}
                                                        </dt>
                                                        <dd>
                                                            {{
                                                                $n(
                                                                    m.milestone_amount,
                                                                    {
                                                                        style:
                                                                            "currency",
                                                                        currency:
                                                                            m.currency,
                                                                        currencyDisplay:
                                                                            "code",
                                                                        maximumFractionDigits: 0,
                                                                        minimumFractionDigits: 0
                                                                    }
                                                                )
                                                            }}
                                                        </dd>

                                                        <dt>
                                                            {{
                                                                $t(
                                                                    "vouchers.total_cost"
                                                                )
                                                            }}
                                                        </dt>
                                                        <dd>
                                                            {{
                                                                $n(
                                                                    m.milestone_amount_cost,
                                                                    {
                                                                        style:
                                                                            "currency",
                                                                        currency:
                                                                            m.currency,
                                                                        currencyDisplay:
                                                                            "code",
                                                                        maximumFractionDigits: 0,
                                                                        minimumFractionDigits: 0
                                                                    }
                                                                )
                                                            }}
                                                        </dd>

                                                        <dt class="text-muted">
                                                            {{
                                                                $t(
                                                                    "vouchers.total_noncost"
                                                                )
                                                            }}
                                                        </dt>
                                                        <dd
                                                            class="text-muted text-ss"
                                                        >
                                                            {{
                                                                $n(
                                                                    m.milestone_amount_noncost,
                                                                    {
                                                                        style:
                                                                            "currency",
                                                                        currency:
                                                                            m.currency,
                                                                        currencyDisplay:
                                                                            "code",
                                                                        maximumFractionDigits: 0,
                                                                        minimumFractionDigits: 0
                                                                    }
                                                                )
                                                            }}
                                                        </dd>
                                                    </dl>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <v-table
                                                    class="table table-sm table-mg table-voucher-report"
                                                >
                                                    <v-thead>
                                                        <v-tr>
                                                            <v-th>{{
                                                                $t(
                                                                    "vouchers.tbl_hdr_category"
                                                                )
                                                            }}</v-th>
                                                            <v-th
                                                                class="text-right"
                                                                >{{
                                                                    $t(
                                                                        "vouchers.tbl_hdr_amount"
                                                                    )
                                                                }}</v-th
                                                            >
                                                        </v-tr>
                                                    </v-thead>
                                                    <v-tbody>
                                                        <v-tr
                                                            v-for="entr in m.voucher_categories"
                                                            :class="{
                                                                'd-none':
                                                                    !BK &&
                                                                    entr.category_function ==
                                                                        2
                                                            }"
                                                        >
                                                            <v-td
                                                                :class="{
                                                                    'text-muted text-bold':
                                                                        entr.category_function ===
                                                                        2,
                                                                    'text-bold text-info': !entr.vouchers
                                                                }"
                                                                >{{
                                                                    entr.category_name
                                                                }}
                                                                <base-button
                                                                    v-if="
                                                                        entr.vouchers
                                                                    "
                                                                    size="sm"
                                                                    type="primary"
                                                                    outline
                                                                    @click="
                                                                        showVouchers(
                                                                            entr.voucher_category_id,
                                                                            m.project_milestone_id
                                                                        )
                                                                    "
                                                                    ><i
                                                                        class="far fa-search-plus"
                                                                    ></i></base-button
                                                            ></v-td>
                                                            <v-td
                                                                class="text-right"
                                                                :class="{
                                                                    'text-muted text-ss text-bold':
                                                                        entr.category_function ===
                                                                        2,
                                                                    'text-bold text-info': !entr.vouchers
                                                                }"
                                                                >{{
                                                                    $n(
                                                                        entr.amount_category,
                                                                        {
                                                                            style:
                                                                                "currency",
                                                                            currency:
                                                                                entr.currency,
                                                                            currencyDisplay:
                                                                                "code",
                                                                            maximumFractionDigits: 0,
                                                                            minimumFractionDigits: 0
                                                                        }
                                                                    )
                                                                }}
                                                            </v-td>
                                                        </v-tr>
                                                        <v-tr v-if="false">
                                                            <v-td>SAMLET</v-td>
                                                            <v-td>{{ m }}</v-td>
                                                            <v-td>
                                                                {{
                                                                    hashed[
                                                                        p
                                                                            .project_id
                                                                    ]
                                                                }}
                                                            </v-td>
                                                        </v-tr>
                                                    </v-tbody>
                                                </v-table>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </card>

                        <template v-if="false">
                            <card
                                body-classes=""
                                v-for="(p, project_id) in meta.projects"
                                :key="project_id"
                            >
                                <div
                                    class="d-flex align-items-center mb-4 justify-content-between"
                                >
                                    <h2 class="">
                                        {{ $t("vouchers.cost_report") }}
                                    </h2>
                                    <cost-submenu
                                        :project-id="project_id"
                                        me="costs"
                                    />
                                </div>
                                <hr />

                                <div
                                    v-for="(m, k) in meta.milestones[
                                        project_id
                                    ]"
                                >
                                    <div class="row">
                                        <div class="col">
                                            <h4>
                                                M{{ m.m_ident }}
                                                {{ m.milestone_name }}
                                            </h4>
                                            <div>
                                                {{
                                                    $t(
                                                        "vouchers.total_in_this_milestone"
                                                    )
                                                }}: {{ m.amount_milestone }}
                                                {{ m.currency }}
                                            </div>
                                        </div>
                                        <div class="col">
                                            <v-table
                                                class="table table-sm table-mg table-voucher-report"
                                            >
                                                <v-thead>
                                                    <v-tr>
                                                        <v-th>{{
                                                            $t(
                                                                "vouchers.tbl_hdr_category"
                                                            )
                                                        }}</v-th>
                                                        <v-th
                                                            class="text-right"
                                                            >{{
                                                                $t(
                                                                    "vouchers.tbl_hdr_amount"
                                                                )
                                                            }}</v-th
                                                        >
                                                    </v-tr>
                                                </v-thead>
                                                <v-tbody>
                                                    <v-tr
                                                        v-for="entr in hashed[
                                                            project_id
                                                        ][
                                                            m
                                                                .project_milestone_id
                                                        ]"
                                                    >
                                                        <v-td>{{
                                                            entr.category_name
                                                        }}</v-td>
                                                        <v-td class="text-right"
                                                            >{{ entr.amount }}
                                                            {{
                                                                entr.currency
                                                            }}</v-td
                                                        >
                                                    </v-tr>
                                                    <v-tr v-if="false">
                                                        <v-td>SAMLET</v-td>
                                                        <v-td>{{ m }}</v-td>
                                                        <v-td>
                                                            {{
                                                                hashed[
                                                                    p.project_id
                                                                ]
                                                            }}
                                                        </v-td>
                                                    </v-tr>
                                                </v-tbody>
                                            </v-table>
                                        </div>
                                    </div>
                                    <hr />
                                </div>
                            </card>
                        </template>

                        <pre v-if="false">{{ meta }}</pre>
                    </template>
                    <template v-else
                        ><div class="alert alert-warning">
                            {{ $t("vouchers.alert_no_stat_data") }}
                        </div></template
                    >
                </div>
            </div>
        </div>
        <portal to="modals">
            <modal
                size="full"
                @close="showVouchersModal = false"
                v-if="showVouchersModal"
                :show="true"
            >
                <template slot="header">{{
                    $t("vouchers.list_of_vouchers")
                }}</template>
                <template slot="default">
                    <v-list-vouchers
                        :project-id="project_id"
                        :voucher-category="voucherCtxCategory"
                        :project-milestone="voucherCtxMilestone"
                /></template>
            </modal>
        </portal>
    </div>
</template>

<style lang="scss">
.mini-text {
    font-weight: normal;
    font-size: 11px;
}

.card-no-milestone {
    background-color: $gray-100;
    border: 1px solid $warning;
}

.table-voucher-report {
    width: 700px;
}
</style>
